import {
    Module,
    VuexModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';
import {
    listAttibute, findByid, createAttibute, update, deleteAttribute
} from '../../services/attribute.js'


@Module({
    namespaced: true,
})

export default class Attribute extends VuexModule {

    // State
    public attributesList = [];
    public currentReadAttribute = {};



    // Actions

    @Action
    public async getAttributesList() {
        try {
            const data = await listAttibute();
            this.context.commit('setAttributesList', data)
        } catch (error) {
            throw error
        }
    }

    @Action
    public async getAttributeById(Id) {
        try {
            const data = await findByid(Id);
            this.context.commit('setCurrentReadAttribute', data)
        } catch (error) {
            throw error
        }
    }

    @Action
    public async createAttribute(payload) {
        try {
            const data = await createAttibute(payload);
            this.context.dispatch('getAttributesList');
            return data;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async updateAttribute(payload) {
        try {
            const data = await update(payload.id, payload.data);
            this.context.dispatch('getAttributesList');
            return data;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async deleteAttribute(payload) {
        try {
            const data = await deleteAttribute(payload);
            this.context.dispatch('getAttributesList');
            return data;
        } catch (error) {
            throw error
        }
    }



    // Mutations
    @Mutation
    public setAttributesList(data: any) {
        this.attributesList = data;
    }

    @Mutation
    public setCurrentReadAttribute(data: any) {
        this.currentReadAttribute = data;
    }


    // getters 
    get GetAttributeList() {
        return this.attributesList;
    }

    get GetCurrentReadAttribute() {
        return this.currentReadAttribute;
    }



}